module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#EFEFEF",
      "padding-bottom": "50px",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "activity-top-box"
  }, [_c('div', {
    staticClass: "activity-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), (_vm.row.style > 2) ? _c('div', {
    staticClass: "detail-header"
  }, [_c('div', {
    staticClass: "user-face"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user_face,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-names"
  }, [_vm._v(_vm._s(_vm.row.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "look-info"
  }, [_vm._v(_vm._s(_vm.row.create_time_ago))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-right",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("分享")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "activity-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  }), _vm._v(" "), (_vm.row.style == '1' && _vm.row.pics.length > 0) ? _c('div', {
    staticClass: "active-item-pics"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.pics[0].url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.pics), function(item, i) {
    return (_vm.row.style == '2') ? _c('div', {
      staticClass: "video-box"
    }, [_c('img', {
      staticClass: "video-img",
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "on-play",
      attrs: {
        "src": require("../../../assets/images/activity/icon-video-play@2x.png"),
        "alt": "",
        "srcset": ""
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.row.pics), function(item, i) {
    return (_vm.row.style == '3') ? _c('div', {
      staticClass: "video-box",
      staticStyle: {
        "width": "60%",
        "margin-left": "40px",
        "position": "relative"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "on-play",
      attrs: {
        "src": require("../../../assets/images/activity/icon-video-play@2x.png"),
        "alt": "",
        "srcset": ""
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.row.style == '4') ? _c('div', {
    class: 'activity-imgs-' + _vm.row.style,
    style: ((_vm.row.pics.length) % 3 == 0 ? 'justify-content:space-between' : '')
  }, _vm._l((_vm.row.pics), function(item, i) {
    return _c('div', {
      style: ((_vm.row.pics.length) % 3 == 0 ? '' : 'margin-right:0.1rem')
    }, [_c('img', {
      staticStyle: {
        "width": "2.3rem",
        "height": "2.3rem",
        "object-fit": "cover"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.previewImages(i)
        }
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.row.style == '5') ? _c('div', {
    class: 'activity-imgs-' + _vm.row.style
  }, [_c('div', {
    staticStyle: {
      "width": "4rem",
      "height": "4rem"
    }
  }, [(_vm.row.pics.length > 0) ? _c('img', {
    staticStyle: {
      "width": "4rem",
      "height": "4rem",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.row.pics[0].url,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.previewImages(0)
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-bottom"
  }, [_c('div', {
    staticClass: "release-time"
  }, [_vm._v(_vm._s(_vm.row.create_time_ago))])]), _vm._v(" "), _c('div', {
    staticClass: "zan-box"
  }, [_c('span', {
    staticClass: "zan-num"
  }, [_vm._v(_vm._s(_vm.row.zan_list.length) + "赞")]), _vm._v(" "), _vm._l((_vm.row.zan_list), function(item, i) {
    return _c('img', {
      key: i,
      staticClass: "user-zan-face",
      attrs: {
        "src": item.user_face,
        "alt": ""
      }
    })
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "comments-box"
  }, [_c('div', {
    staticClass: "comments-box-title"
  }, [_vm._v("评论")]), _vm._v(" "), (_vm.row.comment_list.length > 0) ? _c('div', {
    staticClass: "comments-list-box"
  }, _vm._l((_vm.row.comment_list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "comments-list",
      on: {
        "click": function($event) {
          return _vm.onToUserComment(item)
        },
        "touchstart": function($event) {
          return _vm.showCommentDeleteButton(item, i)
        },
        "touchend": _vm.emptyTime
      }
    }, [_c('div', [_c('div', {
      staticClass: "user-face"
    }, [_c('img', {
      attrs: {
        "src": item.user_face
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-names"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "look-info"
    }, [_vm._v(_vm._s(item.create_time_ago))])])]), _vm._v(" "), (item.to_user_name == null) ? _c('div', {
      staticClass: "comments-content"
    }, [_vm._v(_vm._s(item.content))]) : _c('div', {
      staticClass: "comments-content"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("\n              回复\n              "), _c('span', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v(_vm._s(item.to_user_name) + ":")])]), _vm._v("\n            " + _vm._s(item.content) + "\n          ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "send-comments"
  }, [_c('van-field', {
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.commentsPlaceholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zan-btn"
  }, [(!_vm.row.is_zan) ? _c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-active-de0.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onAddZan
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-active-de1.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onRemoveZan
    }
  })])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetCommentActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetCommentShow),
      callback: function($$v) {
        _vm.sheetCommentShow = $$v
      },
      expression: "sheetCommentShow"
    }
  }), _vm._v(" "), _c('van-image-preview', {
    attrs: {
      "images": _vm.images,
      "start-position": _vm.imagesIndex
    },
    on: {
      "change": _vm.onImagesChange
    },
    scopedSlots: _vm._u([{
      key: "cover",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "position": "fixed",
            "left": "0px",
            "right": "0px",
            "margin": "auto",
            "bottom": "10px",
            "text-align": "center",
            "color": "#fff"
          }
        }, [(_vm.row.photo_service == 1) ? _c('van-button', {
          staticStyle: {
            "margin": "0 auto"
          },
          attrs: {
            "color": "#fb8100",
            "plain": "",
            "type": "primary"
          },
          on: {
            "click": _vm.onDownloadPic
          }
        }, [_vm._v("下载图片")]) : _vm._e()], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7d8a20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/ActivityDetail.vue
// module id = 2265
// module chunks = 0